import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardText,
  CardTitle,
  Label,
  Table,
  Row,
  Col,
} from "reactstrap";
import { useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";

const PersonalInformation = ({
  dataList,
  getprofile,
  PersonalList,
  isLoading,
}) => {
  // const [isLoading, setIsLoading] = useState(true);
  // const [dataList, setDataList] = useState(null);
  // const params = useParams();

  // const getListDataById = async () => {
  //   setIsLoading(true);
  //   try {
  //     const data = { id: params?.mid };
  //     const result = await tutorsModal.PersonalInformationlist(data);
  //     setIsLoading(false);
  //     if (result) {
  //       setDataList(result?.data?.data);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (params.mid !== "") {
  //     getListDataById();
  //   }
  // }, [params.mid]);

  const handleViewFile = (url) => {
    if (!url) {
      console.error("No URL provided.");
      return;
    }
    const newWindow = window.open(url, "_blank"); // Opens the URL in a new tab/window
    if (!newWindow) {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };
  
  console.log("dataListsjkds", getprofile);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Card
          style={{
            width: "35rem",
          }}
        >
          {/* <img
            src={dataList?.qualCertificate}
            height="200px"
            onClick={() => handleDownload(dataList?.qualCertificate)}
          /> */}
          <CardBody>
            <Row>
              <Col md={6}>
                <CardTitle>
                  <Label>Alternate Mobile Number</Label>
                  <p>{dataList?.alternateMobile || "-"}</p>
                </CardTitle>
              </Col>
              <Col md={6}>
                <CardTitle>
                  <Label>DOB</Label>
                  <p>{dataList?.dob || "-"}</p>
                </CardTitle>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <CardTitle>
                  <Label>Gender</Label>
                  <p>{dataList?.gender || "-"}</p>
                </CardTitle>
              </Col>
              <Col md={6}>
                <CardTitle>
                  <Label>Permanent Address</Label>
                  <p>{dataList?.permanentAddress || "-"}</p>
                </CardTitle>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <CardTitle>
                  <Label>Aadhar Number</Label>
                  <p>{dataList?.aadhaar || "-"}</p>
                </CardTitle>
              </Col>

              <Col md={6}>
                <CardTitle>
                  <Label>Highest qualification document</Label>
                  <p
                    onClick={() =>handleViewFile(getprofile?.data?.data?.qualCertificate
                    )}
                    style={{
                      color: "blue",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    (view file)
                  </p>
                </CardTitle>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <CardTitle>
                  <Label>Aadhar Front Photo</Label>
                  <p
                    onClick={() =>
                      handleViewFile(getprofile?.data?.data?.aadhar_front?.link)
                    }
                    style={{
                      color: "blue",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    (view file)
                  </p>
                </CardTitle>
              </Col>

              <Col md={6}>
                <CardTitle>
                  <Label>Aadhar Back Photo</Label>
                  <p
                    onClick={() =>
                      handleViewFile(getprofile?.data?.data?.aadhar_back?.link)
                    }
                    style={{
                      color: "blue",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    (view file)
                  </p>
                </CardTitle>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
      <br />
    </div>
  );
};

export default PersonalInformation;
